import { z } from 'zod';

export const addCalendarSchema = z.object({
  integrationId: z.string().min(1, 'Select an account'),
  calendarUri: z.string().min(1, 'Select a calendar'),
});

export type AddCalendarFormValues = z.infer<typeof addCalendarSchema>;
